import api from '../api';

export interface DemandaContratoSaldoDisponivel {
  saldoDisponivel: number;
}
export interface AbaGeralContrato {
  contratoId: string;

  dadosGerais_Numero?: number;
  dadosGerais_Objeto?: string;
  dadosGerais_ObjetoResumido?: string;
  dadosGerais_CondicaoPagamento?: string;

  fornecedor_Numero?: number;
  fornecedor_Nome?: string;
  fornecedor_NomeResumido?: string;
  fornecedor_Cnpj?: string;

  caracteristicaServico_TipoServicoId: string;
  caracteristicaServico_LocaisServicoList: string[];
  caracteristicaServico_LocaisServicoCheckbox: string[];
  caracteristicaServico_Localidade: string;
  caracteristicaServico_Descricao: string;
  caracteristicaServico_CreditoPisCofins: boolean;
  caracteristicaServico_MaoDeObraAlocadaPTR: boolean;
  caracteristicaServico_MaoDeObraAlocadaForaPTR: boolean;

  dadoInicial_DataInicio?: Date;
  dadoInicial_DataTermino?: Date;
  dadoInicial_Valor: number;
  dadoInicial_Valor_string: string;
  dadoInicial_CondicaoPagamento: string;
  dadoInicial_Dias: number;

  dadoConsolidado_DataEncerramento?: Date;
  dadoConsolidado_Status: string;
  dadoConsolidado_ValorAtual: number;
  dadoConsolidado_SaldoAtual: number;
  dadoConsolidado_DiasParaEncerramento: number;
  dadoConsolidado_Situacao: string;
  dadoConsolidado_ValorAtual_String: string;

  isNovasSubcontratadasAutorizadas?: boolean;
  isFaturamentoDireto?: boolean;
}

export const getAbaGeralById = (id: any) => api.get<AbaGeralContrato>(`contratos/infogeral/${id}`);
export const getAbaGeralByNumero = (numero: any) => api.get<AbaGeralContrato>(`contratos/infogeral/numero/${numero}`);

export const getDemandaContratoSaldoDisponivel = (numeroContrato: any) => api.get<DemandaContratoSaldoDisponivel>(`demandas/contrato/saldoDisponivel/${numeroContrato}`);

export const updateDadosGeraisContrato = (abaGeralContrato: AbaGeralContrato) => {
  return api.put(`contratos/dadosgerais/${abaGeralContrato.contratoId}`, abaGeralContrato);
};
export const updateFornecedorContrato = (abaGeralContrato: AbaGeralContrato) => {
  return api.put(`contratos/fornecedorContrato/${abaGeralContrato.contratoId}`, abaGeralContrato);
};
export const updatesDadosIniciais = (abaGeralContrato: AbaGeralContrato) => {
  return api.put(`contratos/updatesDadosIniciais/${abaGeralContrato.contratoId}`, abaGeralContrato);
};

export const updatesDadosConsolidados = (abaGeralContrato: AbaGeralContrato) => {
  return api.put(`contratos/updatesDadosConsolidados/${abaGeralContrato.contratoId}`, abaGeralContrato);
};

export const updateDadosCaracteristicaServicoContrato = (abaGeralContrato: AbaGeralContrato) =>
  api.put(`contratos/caracteristicasservico/${abaGeralContrato.contratoId}`, abaGeralContrato);
export const deleteContrato = (id: string) => api.delete(`contratos/${id}`);

export const updateDadosClassificacaoServicoContrato = (dados: any) =>
  api.put(`contratos/classificacaoservico/${dados.contratoId}`, dados);
